import React from "react"
import appstore from "./public/appstore.svg"
import gecko from "./public/gecko.svg"
import grid from "./public/grid.svg"
import labyrinth from "./public/labyrinth.png"
import preview from "./public/preview.png"

export default function Plain() {
  const [showOverlay, setShowOverlay] = React.useState(false)

  return (
    <main style={{ backgroundImage: `url(${grid})` }}>
      <div className="h-screen relative w-screen overflow-hidden">
        <div className="absolute bottom-0 z-1 md:max-h-96">
          <img src={labyrinth} className="md:max-h-96 w-screen object-cover" />
        </div>

        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-auto md:right-10 md:bottom-10 flex md:flex-col gap-2 z-10">
          <a href="https://apps.apple.com/us/app/gecko-med/id6737719743" target="_blank" rel="noopener noreferrer">
            <img src={appstore} className="h-8 md:h-12" />
          </a>

          {/* <a href="https://play.google.com/store/apps/details?id=com.geckomed.app" target="_blank" rel="noopener noreferrer">
            <img src={playstore} className="h-8 md:h-12" />
          </a> */}
        </div>

        <div className="relative z-2 space-y-10 md:space-y-0 pt-10 md:pt-20">
          <div className="self-center flex flex-col gap-6 items-center">
            <div
              className="relative z-10 cursor-pointer"
              onClick={() => {
                localStorage.setItem("is_uwu", "true")
                window.location.reload()
              }}
            >
              <img src={gecko} className="h-20" />
            </div>

            <div className="relative flex flex-col items-center">
              <>
                <div
                  className="fixed inset-0 ease-in-out duration-500 transition-all bg-black/10 left-0 right-0 z-1 h-screen w-screen backdrop-blur-md"
                  style={{ opacity: showOverlay ? 1 : 0 }}
                />
                {/* <img
                src="/study.png"
                className="absolute z-20 transition-all duration-500 ease-in-out"
                style={{ pointerEvents: "none", opacity: showOverlay ? 1 : 0 }}
              /> */}
              </>
              <p
                className="sm:text-xl border-b-2 border-dashed relative z-10 transition-colors ease-linear text-gray-500 text-center"
                style={{
                  color: showOverlay ? "black" : undefined,
                  cursor: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='48' viewport='0 0 100 100' style='fill:black;font-size:24px;'><text y='50%'>🎉</text></svg>") 16 0, auto`,
                }}
                onMouseOver={() => setShowOverlay(true)}
                onMouseLeave={() => setShowOverlay(false)}
              >
                Medicine Made Fun!
              </p>
              <p className="sm:text-xl text-gray-500 text-center">Stay Tuned for updates.</p>
            </div>
          </div>

          <img
            src={preview}
            loading="eager"
            className="mx-auto transition-all ease-in-out duration-500 relative z-1"
            style={{ width: "calc(100vh * 4 / 7)" }}
          />
        </div>
      </div>
    </main>
  )
}
